import { api } from "@data-phone/react-resource-server-auth";
import { useMutation } from "react-query";

export const getPlacesByText = async (text: string) => {
    const response = await api.get(`${process.env.REACT_APP_CONTACT_API_URL}/places?input=${text}`);
    return response.data;
};
export const useGetPlacesByText = () => {
    return useMutation((text: string) => getPlacesByText(text));
};

export const getPlaceById = async (id: string) => {
    const response = await api.get(`${process.env.REACT_APP_CONTACT_API_URL}/places/details?placeId=${id}`);
    return response.data;
}